export enum EConstructionType {
  'HOUSE' = 'house',
  'APARTMENT' = 'apartment',
  "OFFICE" = 'office',
  "CONSULTING_ROOM" = 'consulting_room',
  "WAREHOUSE" = 'warehouse',
  "INDUSTRIAL_BUILDING" = 'industrial_building',
  "SHOP" = 'shop',
  "SHOP_SHOPPING_CENTER" = 'shop_shopping_center',
  "TERRAIN" = 'terrain',
  "RANCH" = 'ranch',
  "BUILDING" = 'building',
  "HOTEL" = 'hotel',
  "EVENT_HALL" = 'event_hall',
  "COTTAGE" = 'cottage',
  "OTHER" = 'other',
  "NONE" = 0,
}

export enum EPropertyType {
  RENT = 'for-rent',
  SALE = 'for-sale',
}

export enum EPropertyOrder {
  RELEVANCE = 'Relevancia',
  RECENT_PUBLISHED = 'Recién publicadas',
  MIN_TO_MAX_PRICE = 'Menor a mayor precio',
  MAX_TO_MIN_PRICE = 'Mayor a menor precio',
  MAX_TO_MIN_SIZE = 'Más grandes',
  MIN_TO_MAX_SIZE = 'Más pequeños',
  OLDEST = 'Mas antiguos',
}

export enum ECriteriaSort {
  CREATED = 'created',
  DISTANCE = 'distance',
  RANKING = 'ranking',
  CHEAP = 'cheap',
  EXPENSIVE = 'expensive',
  LARGE = 'large',
  SMALL = 'small',
  OLDEST = 'oldest',
}
